import { AppBar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Icon, IconButton, Stack, TextField, Toolbar, Typography } from "@mui/material";
import React, { forwardRef, useRef } from "react";
import AgGridTable from "../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useState, useEffect } from "react";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import UtilizedView from "./UtilizedView";

const LCUtilized = forwardRef((props, ref) => {
    const gridRef = useRef()
    const [openTopUp, setOpenTopUp] = useState(props.open || true);
    const [rowData, setRowData] = useState([]);
    const [editRowData, setEditRowData] = useState([]);
    const [openView, setOpenView] = useState(false)
    const [viewId, setViewId] = useState()
    const [successMsg, setSuccessMsg] = useState();
    const [penddingView, setPenddingView] = useState(false)
    const [utilizedData, setUtilizedData] = useState({
        company: '',
        companyName: '',
        documentCreditNo: '',
    })

    const hanleEditUtilized = (event) => {
        const index = event.node.rowIndex;
        gridRef.current.api.setFocusedCell(index, 'bankRefNo')
        gridRef.current.api.startEditingCell({
            rowIndex: index,
            colKey: 'bankRefNo',
        });
    }

    const handleActions = (params) => {
        return params.data && <>
            <IconButton size="small" className="p-0" ><Icon onClick={() => hanleViewUtilized(params.data.id)}>visibility</Icon></IconButton>
            <IconButton size="small" className="p-0" ><Icon onClick={() => hanleEditUtilized(params)}>edit</Icon></IconButton>
        </>
    }

    const renderCurrency = (props) => {
        return <span style={{ display: "flex" }}>
            <p>{new Intl.NumberFormat('en-US').format(props?.value)}</p>
        </span>;
    };
    
    const [columnDefs, setColumnDefs] = useState([
        { field: 'bankRefNo' },
        { field: 'doc_date', editable: false, headerName: 'Doc Date'},
        { field: 'docNo', editable: false, },
        { field: 'totalAmount', editable: false,cellRenderer:renderCurrency  },
        { field: 'blDate', editable: false, },
        { field: 'action', editable: false, headerName: 'View / Edit', cellRenderer: handleActions },
    ]);
    const lcUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.lcDocument}`;
    const lcDocUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.lcDocuments}`;

    const handleClose = () => {
        setOpenTopUp(false)
        props.handleClose()
    }
    const closeOpenLCTopup = () => {
        setOpenView(false);
        setPenddingView(false)
    }
    const loadUtilizedData = async () => {
        let letterOfCredits = { letterOfCredit: props.lcId }
        const list = await OAuthService.getPostList(lcUrl + `/getAllLcDocuments`, letterOfCredits);
        if (list.data) {
            const listData = list.data.map((data) => {
                if (data.listOfOrder && data.listOfOrder.length > 0) {
                    data.blDate = data.listOfOrder[0].blDate
                }
                return data
            })
            setRowData(listData);
            setEditRowData(JSON.parse(JSON.stringify(listData)))
            list.data.length > 0 && setUtilizedData({
                company: list.data[0].letterOfCredit.company,
                companyName: list.data[0].letterOfCredit.companyName,
                documentCreditNo: list.data[0].letterOfCredit.documentCreditNo
            })
        }
    }

    useEffect(() => {
        loadUtilizedData()
    }, [])

    const hanleViewUtilized = (id) => {
        setViewId(id)
        setOpenView(true)
        setPenddingView(true)
    }

    useEffect(() => {
        props.successMsg(successMsg)
    }, [successMsg]);

    const onCellValueChanged = (params) => {
        const updated = rowData.map((data) => {
            if (data.id === params.data.id) {
                data.bankRefNo = params.data.bankRefNo ? params.data.bankRefNo : null
            }
            return data;
        })
        setRowData(updated)
    }

    const handleSave = async () => {
        if (rowData.length > 0) {
            try {
                await Promise.all(rowData.map(async (data) => {
                    if (data.bankRefNo) {
                        await OAuthService.updateData(lcDocUrl, data.id, { bankRefNo: data.bankRefNo });
                        
                    }
                }))
                
                setSuccessMsg("Bank ref Updated successfully")
                return "Bank ref Updated successfully";
            } catch (error) {
                
            }
        }
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                onClose={handleClose}
                open={openTopUp}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                            Utilized - List Of Claimed Documents
                        </Typography>
                        <Button onClick={handleClose}>
                            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers>
                    <Grid container spacing={2} className="mt-8">
                        <Grid item xs={8}>
                            <Stack>
                                <lable>Client Name</lable>
                                <TextField
                                    value={utilizedData.companyName}
                                    name="customer"
                                    disabled
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}

                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                value={utilizedData.company}
                                name="customer"
                                disabled
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}
                                style={{ marginTop: "2rem" }}

                            />
                        </Grid>
                    </Grid>
                    <Grid container className="mt-8" >
                        <Grid item xs={12}>
                            <Stack>
                                <lable>Documentary Credit No</lable>
                                <TextField
                                    value={utilizedData.documentCreditNo}
                                    // name="customer"
                                    disabled
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}

                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Divider />
                    <div className="mt-8 h-[300px]" >
                        <AgGridTable
                            rowData={rowData}
                            columnDefs={columnDefs}
                            gridRef={gridRef}
                            onCellValueChanged={onCellValueChanged}
                        // onGridReady={onGridReady}
                        />
                        <div className="flex justify-end items-baseline mt-8">
                            <label className="mr-8" >Total Selected</label>
                            <TextField
                                name="total"
                                value={rowData?.reduce((total, row) => total + row.totalAmount, 0)}
                                disabled
                                inputProps={{
                                    sx: { 'width': '80px', 'height': '5px' },
                                }} />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleSave}
                        disabled={JSON.stringify(editRowData) === JSON.stringify(rowData)}
                    >
                        <FuseSvgIcon>material-solid:save</FuseSvgIcon>
                    </Button>
                </DialogActions>
            </Dialog>
            {(openView || penddingView) && <UtilizedView open={openView} id={viewId} handleClose={closeOpenLCTopup} ViewOptions={openView ? "UtilizeView" : penddingView ? 'PendingView' : ''} />}
        </>
    )
})
export default LCUtilized